import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { AgeGate } from './AgeGate';

const isDateOpsRoute = window.location.pathname === '/date-ops' ||
  window.location.pathname.startsWith('/date-ops/');
const DateOpsApp = React.lazy(() =>
  import('./date-ops/DateOpsApp').then((module) => ({ default: module.DateOpsApp })),
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {isDateOpsRoute ? (
      <Suspense fallback={null}>
        <DateOpsApp />
      </Suspense>
    ) : (
      <AgeGate />
    )}
  </React.StrictMode>,
);
